import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurImage } from "../../../Baseurl";

export default function ViewStaff() {
  const location = useLocation();
  const navigate = useNavigate();
  const staff = location.state?.staff;

  // Helper function to get staff image URL
  const getStaffImageUrl = (staff) => {
    if (staff.personalPhoto && staff.personalPhoto !== "null" && staff.personalPhoto !== "undefined") {
      return `${baseurImage}${staff.personalPhoto}`;
    }
    // Return default avatar if no personal photo
    return "../assets/images/user/avatar-2.jpg";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  if (!staff) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="col-12">
            <div className="card table-card">
              <div className="tableHeader">
                <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                    onClick={() => navigate(-1)}
                    title="Back"
                  >
                    &larr;
                  </span>
                  Staff Details
                </h5>
              </div>
              <div className="card-body text-center">
                <p>No staff data available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                Staff Details
              </h5>
            </div>
            <div className="card-body" style={{ margin: "15px" }}>
              <div className="row justify-content-center mb-4">
                <div className="col-md-12">
                  <div className="drImg">
                    <img
                      src={getStaffImageUrl(staff)}
                      alt={staff.fullName}
                      onError={(e) => { e.currentTarget.src = "../assets/images/user/avatar-2.jpg"; }}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                {[
                  ["Prefix", staff.prefix || "N/A"],
                  ["First Name", staff.fullName],
                  ["Last Name", staff.shortName],
                  ["Email", staff.email],
                  ["Phone Number", staff.phoneNumber],
                  ["Civil ID", staff.civilId],
                  ["Date of Birth", formatDate(staff.dateOfBirth)],
                  ["Gender", staff.gender],
                  ["Role", staff.role],
                  ["License ID", staff.licenseId || "N/A"],
                  ["Passport", staff.passport || "N/A"],
                  // ["Specialty", staff.specialty || "N/A"],

                  // ["Short Name", staff.shortName || "N/A"],
                ].map(([label, value], idx) => (
                  <div className="col-md-6 mb-3" key={idx}>
                    <label className="form-label fw-bold">{label}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={value ?? ""}
                      disabled
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 